import React from 'react';
import { View,Text } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const comotrocar =()=>{
return(
<View style={{backgroundColor:'#01150E',height:'100%',width:'100%'}}>
<View style={{margin:10,flexDirection:'row'}}> 
<Ionicons name="ios-checkmark-circle" size={30} color="white" />
<Text style={{color:'white'}}>Após o cadastro antes de realizar uma troca de saldo é preciso cadastrar seus dados bancários, caso tenha alguma informação a mais na hora do cadastro bancario coloque os dados no campo observação </Text>  
</View>

<View style={{margin:10,flexDirection:'row'}}> 
<Ionicons name="ios-checkmark-circle" size={30} color="white" />
<Text style={{color:'white'}}>Após cadastrar seus dados bancários, você deve ir para o menu principal e clicar na opção SACAR SALDO </Text>  
</View>

<View style={{margin:10,flexDirection:'row'}}> 
<Ionicons name="ios-checkmark-circle" size={30} color="white" />
<Text style={{color:'white'}}>A taxa Atual é de 5% mais Taxa de trasanção no valor de $70.00 Reais </Text> 
</View>

<View style={{margin:10,flexDirection:'row'}}> 
<Ionicons name="ios-checkmark-circle" size={30} color="white" />
<Text style={{color:'white'}}>Preencha todos os dados com cuidado, selecione quantas parcelas deseja </Text> 
</View>

<View style={{margin:10,flexDirection:'row'}}> 
<Ionicons name="ios-checkmark-circle" size={30} color="white" />
<Text style={{color:'white'}}>Então click no botão trocar e aguarde a resposta</Text>  
</View>

<View style={{margin:10,flexDirection:'row'}}> 
<Ionicons name="ios-checkmark-circle" size={30} color="white" />
<Text style={{color:'white'}}>Se a transação ocorrer tudo ok, você recebera seu dinheiro em media leva menos de uma hora</Text>  
</View>

<View style={{margin:10,flexDirection:'row'}}> 
<Ionicons name="ios-checkmark-circle" size={30} color="white" />
<Text style={{color:'white'}}>Para ver o Status da transação você deve clicar no botão troca relatórios</Text>  
</View>

<View style={{margin:10,flexDirection:'row'}}> 
<Ionicons name="ios-checkmark-circle" size={30} color="white" />
<Text style={{color:'white'}}>Voce pode pedir suporte pelo botão do whatsapp no canto inferior esquerdo do menu principal</Text>  
</View>

</View>

);


}

export default comotrocar;